import { render, staticRenderFns } from "./createRoleTask.vue?vue&type=template&id=7fa48036&"
import script from "./createRoleTask.vue?vue&type=script&lang=js&"
export * from "./createRoleTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports